/**
 * Created by Udara Prabath
 * Date: 10/30/2020
 * Using: IntelliJ IDEA
 */

import React from "react";
import './LessonItemPurchase.scss'
import {Button, Col, Row} from "reactstrap";
import {lang, language} from "../../const/language";
import Slider from "react-slick";
import Placeholder from "../../assets/img/common/placeholder.png";
import * as actionCreator from "../../store/domain/classes/action";
import * as actionSpinnerCreator from "../../store/domain/spinner/action";
import * as actionModalCreator from "../../store/domain/modal/action";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import * as constants from "../../const/constants";
import {BOUGHT_TEXT, RE_BUY_TEXT} from "../../const/constants";
import {getSliderSetting} from "../../utils/commonFunc";


class LessonItem extends React.Component {

    viewLesson = (lesson) => {
        this.props.history.push({
            pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_SELECTED_LESSON_ROUTE}`,
            state: {
                ...lesson,
                btnStatus: BOUGHT_TEXT,
                firstWeek: this.props.firstWeek,
                classId: this.props.classId
            }
        })
    };

    purchaseHandler = (lessonId) => {
        this.props.setPaymentModal(true,{lessonId:lessonId})
    };

    render() {
        const {lessons} = this.props;
        let settings = getSliderSetting(lessons);

        return (
            <div>
                <div className="lesson-item-purchase">
                    <Slider {...settings}>
                        {
                            lessons.map((item,index)=>{
                                return(
                                    <div key={index}>
                                        <div className={`slideshow-wrapper shadow border-0 card`}>
                                            <div className={"display-inline slideshow-user-wrapper"}>
                                                <img
                                                    src={item.image ? item.image : Placeholder}
                                                    alt={"."}
                                                    className={"blur-img"}/>
                                                <img
                                                    src={item.image ? item.image : Placeholder}
                                                    alt={"."}
                                                    className={"slideshow-pro-image"}/>
                                                <div className={"slideshow-middle"}>
                                                    <div className={"cursor minHeight mb-3"}>
                                                        <div onClick={()=> this.viewLesson(item)}>
                                                            <h4 className={"topic"}>{item.name}</h4>

                                                            <Row className={"card-row"}>
                                                                <Col xs="12"><p className={"description"}>{item.description}</p></Col>
                                                            </Row>
                                                        </div>
                                                        <div className={"btn-ctrl"}>
                                                            <Button className={"reg-btn com-btn bold-text"}
                                                                    onClick={()=> this.viewLesson(item)}>
                                                                {language[lang].viewLessonBtnText}
                                                            </Button>
                                                            {
                                                                item.buttonStatus === RE_BUY_TEXT &&
                                                                <Button className={"log-btn com-btn bold-text mt-3"}
                                                                        onClick={()=>this.purchaseHandler(item.id)}>
                                                                    {language[lang].RePaidForTheLesson}
                                                                </Button>
                                                            }
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </Slider>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
    setPaymentModal: (data,value) => dispatch(actionModalCreator.setPaymentModal(data,value))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LessonItem));
